import React, { useEffect, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Radar } from "lucide-react";

// Rotating archive loading phrases (brand voice).
export const ARCHIVE_PHRASES = [
  "Accessing Archive\u2026",
  "Connecting the Nodes\u2026",
  "Following the Thread\u2026",
  "Searching the Codex\u2026",
  "Opening Case File\u2026",
];

// Terminal-style loader with rotating brand copy and a blinking caret.
export function Spinner({ label }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (label) return; // fixed label provided
    const t = setInterval(() => setIdx((i) => (i + 1) % ARCHIVE_PHRASES.length), 1600);
    return () => clearInterval(t);
  }, [label]);
  const text = label || ARCHIVE_PHRASES[idx];
  return (
    <div className="flex items-center justify-center py-16" data-testid="archive-loader">
      <div className="codex-terminal codex-scanlines flex items-center gap-3 px-4 py-3">
        <Radar className="h-4 w-4 animate-spin text-[color:var(--codex-amber)]" style={{ animationDuration: "2.4s" }} />
        <span className="codex-caret text-sm tracking-[0.08em]" data-testid="terminal-loading-text">{text}</span>
      </div>
    </div>
  );
}

export function CardGridSkeleton({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="codex-card p-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-3 h-5 w-3/4" />
          <Skeleton className="mt-3 h-3 w-full" />
          <Skeleton className="mt-2 h-3 w-5/6" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, children }) {
  return (
    <div className="codex-glass flex flex-col items-center justify-center rounded-2xl px-6 py-14 text-center">
      {Icon ? <Icon className="h-8 w-8 text-gold-light/70" /> : null}
      <h3 className="mt-4 font-serif text-xl">{title}</h3>
      {children ? <div className="mt-2 max-w-md text-sm text-muted-foreground">{children}</div> : null}
    </div>
  );
}
